<div class="accept-terms-notice" *ngIf="term" role="dialog" aria-live="polite">
  <p class="accept-terms-text">{{ term.termContent }}</p>
  <div class="accept-terms-buttons">
    <button round-button filled="filled" color="warn" size="large" type="button" (click)="accept()" i18n>Accept</button>
    <button round-button color="warn" size="large" type="button" (click)="reject()" i18n>Reject</button>
  </div>
</div>
